import React from "react";
import { Button } from "reactstrap";
import Select from "react-select";

const emptyRow = () => ({ measurement_type_id: null, unit: null, value: '' });

const ProductMeasurements = ({ rows = [], onChange, measurementTypeOptions = [], unitOptions = [], errors }) => {
    const handleAdd = () => onChange([...rows, emptyRow()]);

    const handleDelete = (index) => {
        const updated = rows.filter((_, i) => i !== index);
        onChange(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = rows.map((row, i) => i === index ? { ...row, [field]: value } : row);
        onChange(updated);
    };

    return (
        <div>
            {rows.length > 0 && (
                <div className="table-responsive">
                    <table className="table table-bordered table-sm mb-3">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: '40%' }}>Measurement Type</th>
                                <th style={{ width: '20%' }}>Unit</th>
                                <th style={{ width: '25%' }}>Value</th>
                                <th style={{ width: '15%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => {
                                const usedIds = rows
                                    .map((r, i) => (i !== index ? r.measurement_type_id : null))
                                    .filter(Boolean);
                                const availableOptions = measurementTypeOptions.filter((o) => !usedIds.includes(o.id));
                                return (
                                <tr key={index}>
                                    <td>
                                        <Select
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 100 }), control: base => ({ ...base, minHeight: 32 }) }}
                                            getOptionLabel={(o) => o.display_name}
                                            getOptionValue={(o) => o.id}
                                            value={measurementTypeOptions.find(o => o.id === row.measurement_type_id) || null}
                                            options={availableOptions}
                                            onChange={(e) => handleChange(index, 'measurement_type_id', e?.id ?? null)}
                                            placeholder="Select type..."
                                            isClearable
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 100 }), control: base => ({ ...base, minHeight: 32 }) }}
                                            value={unitOptions.find(o => o.value === row.unit) || null}
                                            options={unitOptions}
                                            onChange={(e) => handleChange(index, 'unit', e?.value ?? null)}
                                            placeholder="Unit..."
                                            isClearable
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            className={`form-control form-control-sm ${errors?.product_measurements?.[index]?.value ? 'is-invalid' : ''}`}
                                            value={row.value ?? ''}
                                            placeholder="e.g. 124.5"
                                            onChange={(e) => handleChange(index, 'value', e.target.value)}
                                        />
                                        {errors?.product_measurements?.[index]?.value && (
                                            <div className="invalid-feedback">
                                                {errors.product_measurements[index].value.message}
                                            </div>
                                        )}
                                    </td>
                                    <td className="text-center">
                                        <Button color="danger" size="sm" onClick={() => handleDelete(index)}>
                                            &times;
                                        </Button>
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            <Button color="primary" size="sm" outline onClick={handleAdd}>
                + Add Row
            </Button>
        </div>
    );
};

export default ProductMeasurements;
